import { Box } from '@mantine/core';

import classes from './IconBox.module.css';

interface IconBoxProps {
  icon: string;
  alt?: string;
  title?: string;
  'data-pw'?: string;
}

export const IconBox: React.FC<IconBoxProps> = ({ icon, alt, title, 'data-pw': dataPw }) => {
  return (
    <Box className={classes.svgIcon} title={title} data-pw={dataPw}>
      <img src={icon} alt={alt} />
    </Box>
  );
};
